export const formatNameForPatientChartTitle = (firstName = '', lastName = '') => {
  if (!firstName || !lastName) {
    return ''
  }
  return `${firstName.charAt(0).toUpperCase()}. ${lastName.charAt(0).toUpperCase()}${lastName.slice(1)}`
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getFreeDrugRuleLayout = (stateName) => `<div class="drug-rules-container">
      State:
     <span class="drug-rules-answer">
      ${stateName || '--'}
      </span>
      <div class="drug-rules-statement">
       Drug Screening Requirements:
      <span class="drug-rules-answer">
      Regular drug screen not required by state
      </span>
        </div>
     </div>`

export const BACKEND_TO_UI_STATUS = {
  none: 'Compliant',
  onhold: 'On hold',
  drugscreenrequired: 'Must complete drug screen',
  inpersonvisitrequired: 'Must complete in-person visit',
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function transformBackendToUIStatus(backendStatus) {
  // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
  return BACKEND_TO_UI_STATUS[backendStatus] || 'Compliant'
}
